import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import saveByteArray from "src/util/saveByteArray";
import { ITrade } from "../interfaces/trade/ITrade";
import { TradePhase } from "../interfaces/UserInterface";
import ITradeResumo from '../interfaces/trade/ITradeResumo';
import {IDocumentUpload} from '../interfaces/trade/Document/IDocumentUpload';
enum TradeServiceEnum {
  downloadTradeContractByTradeId = "/download-contract/",
  // getByPrecatorioId = "/precatorio/",
  putContractInformationByTradeId = "/{tradeId}/contract-information",
  putUploadMarriageDocument = "/{tradeId}/upload-marriage-document",
  postUploadDocumentByTradeId = "/{tradeId}/upload-document",
  putRequestSignature = "/{tradeId}/request-signature",
  putBankingChannelById = "/{tradeId}/banking-channel",
  getAllTradeSummary = "/get-all-summary",
  getTradeContractInformationByTradeId = "/get-contract-information-by-trade-id/",
  getTradeInformationByTradeId = "/get-trade-information-by-id/",
  getContractSignatureByTradeIdAndPhase = "/get-contract-signature?tradeId=",
  putAcceptUseTerm = "/{tradeId}/accept-use-term"
}

export default class TradeService<T> extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade");
  }

  public downloadTradeContractByTradeId = async (tradeId: number): Promise<any> => {
    const data = await this.GET(TradeServiceEnum.downloadTradeContractByTradeId + tradeId, "blob");
    saveByteArray("Contrato.zip", data);
    return data;
  };

  public putContractInformationByTradeId = async (tradeId: number, requestObject): Promise<T> =>
    await this.PUT(TradeServiceEnum.putContractInformationByTradeId.replace("{tradeId}", tradeId.toString()), requestObject);
  public putUploadMarriageDocument = async (tradeId: number, requestObject): Promise<T> =>
    await this.PUT(TradeServiceEnum.putUploadMarriageDocument.replace("{tradeId}", tradeId.toString()), requestObject);
  public postUploadDocumentById = async (tradeId: number, documents: IDocumentUpload): Promise<T> =>
    await this.POST(TradeServiceEnum.postUploadDocumentByTradeId.replace("{tradeId}", tradeId.toString()), documents);
  public putRequestSignatureById = async (tradeId: number): Promise<any> => await this.PUT(TradeServiceEnum.putRequestSignature.replace("{tradeId}", tradeId.toString()), null);
  public putBankingChannelById = async (tradeId: number, data): Promise<any> =>
    await this.PUT(TradeServiceEnum.putBankingChannelById.replace("{tradeId}", tradeId.toString()), data);
  public getAllTradeSummary = async (): Promise<ITradeResumo[]> => await this.GET(TradeServiceEnum.getAllTradeSummary);
  public getTradeContractInformationByTradeId = async (tradeId: number): Promise<ITrade> => await this.GET(TradeServiceEnum.getTradeContractInformationByTradeId + tradeId);
  public getInformationByTradeId = async (tradeId: number): Promise<ITrade> => await this.GET(TradeServiceEnum.getTradeInformationByTradeId + tradeId);
  public getContractSignatureByTradeIdAndPhase = async (tradeId: number, tradePhase: TradePhase) =>
    await this.GET(TradeServiceEnum.getContractSignatureByTradeIdAndPhase + tradeId + `&tradePhase=${tradePhase}`);
  public putAcceptUseTerm = async (tradeId: number) => await this.PUT(TradeServiceEnum.putAcceptUseTerm.replace("{tradeId}", tradeId.toString()), null);
}



// WEBPACK FOOTER //
// ./src/services/api/Trade.service.ts